export function payWithAli(html: string, callback?: () => void) {
  setTimeout(() => {
    const blockPopup = window.open("about:blank", "_blank");
    if (!blockPopup) return;

    blockPopup.document.body.innerHTML = html;
    blockPopup.document.getElementsByTagName("form")[0].submit();

    callback?.();
  });
}
